import { Component, OnInit, ViewChild } from "@angular/core";

import { CustomerContectService } from "../customer-contect.service";
import { SwalComponent } from '@sweetalert2/ngx-sweetalert2';
import notify from "devextreme/ui/notify";

@Component({
  selector: 'app-customer-contect-listing',
  templateUrl: './customer-contect-listing.component.html',
  styleUrls: ['./customer-contect-listing.component.scss']
})
export class CustomerContectListingComponent implements OnInit {
  loading: boolean;
  dataSource: any[];
  @ViewChild("saveSwal") private saveSwal: SwalComponent;
  constructor(private customerService: CustomerContectService) { }

  ngOnInit() {
    this.dataSource = [];
    this.getAllCustomerContactLogin();
  }

  /**
   * @name deleteCustomerContactLogin
   * @method GET
   * @param {number} CustomerContactLoginId
   * @return Promise
   */
  deleteCustomerContactLogin(CustomerContactLoginId) {
    this.loading = true;
    this.customerService
      .deleteCustomerContactLogin(CustomerContactLoginId)
      .then((response: any) => {
        if (response.data.completed) {
          this.loading = false;
          this.saveSwal.swalOptions = {
            icon: "success",
            titleText: response.data.message,
            showConfirmButton: false,
            timer: 1500
          };
          this.saveSwal.fire().then((res: any) => {
            this.getAllCustomerContactLogin();
          });
        } else {
          this.loading = false;
          const option = {
            width: 300,
            displayTime: 3000,
            message: response.data.message,
            type: "error"
          };
          notify(option);
        }
      })
      .catch(error => {
        this.loading = false;
        console.log(error);
        const option = {
          width: 300,
          displayTime: 3000,
          message: error.error,
          type: "error"
        };
        notify(option);
      });
  }
  /**
 * @name getAllCustomerContactLogin
 * @returns CustomerContactLogin
 */
  getAllCustomerContactLogin() {
    this.loading = true;
    this.customerService
      .getAllCustomerContactLogin()
      .then(response => {
        if (response.data.completed) {
          this.dataSource = response.data.payload;
          this.loading = false;
        } else {
          const option = {
            width: 300,
            displayTime: 3000,
            message: response.data.message,
            type: "error"
          };
          notify(option);
        }
        this.loading = false;
      })
      .catch(error => {
        this.loading = false;
        const option = {
          width: 300,
          displayTime: 3000,
          message: error.error,
          type: "error"
        };
        notify(option);
      });
  }
}
